import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './MobIconButton.css';

interface MobIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Screen-reader label — required, icon has no visible text. */
  ariaLabel: string;
  /** When true, the child icon rotates (use for refresh-in-progress state). */
  spinning?: boolean;
  children: ReactNode;
}

export function MobIconButton({
  ariaLabel,
  spinning = false,
  children,
  className,
  type = 'button',
  ...rest
}: MobIconButtonProps) {
  const cls = [
    'mob-icobtn',
    spinning ? 'is-spinning' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} aria-label={ariaLabel} className={cls} {...rest}>
      {children}
    </button>
  );
}
